import { useQuery } from '@apollo/client/react';
import { Box, Grid } from '@mui/material';
import React, { useContext, useState } from 'react';

import DeliveryRegisterV2 from './DeliveryRegisterV2';
import TimelineRibbonV2 from './TimelineRibbonV2';
import UnifiedRegistersCardV2, { type RegisterTabKey } from './UnifiedRegistersCardV2';

import { ReportContext } from '@/Contexts/ReportContext';
import { GetReportIssuesDocument, type Issue } from '@/graphql/generated/graphql';

const ReportDetailsV2: React.FC = () => {
  const { selectedReport } = useContext(ReportContext);
  const [activeTab, setActiveTab] = useState<RegisterTabKey>('people');
  const [selectedDiaryEntry, setSelectedDiaryEntry] = useState<Issue | null>(null);

  const { data: issuesData } = useQuery(GetReportIssuesDocument, {
    skip: !selectedReport?.id,
    variables: {
      reportId: selectedReport?.id as string,
    },
  });

  const issues = (issuesData?.getReportIssues as Issue[]) || [];

  return (
    <Box
      data-testid="report-details"
      sx={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        px: 2.5,
        py: 2,
        backgroundColor: '#F8FAFC',
        minHeight: 'calc(100vh - 115px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Tier 1: Always-Visible 24h Site Timeline Ribbon (No hidden full-screen accordion) */}
      <TimelineRibbonV2
        issues={issues}
        selectedIssue={selectedDiaryEntry}
        onSelectIssue={(issue) => setSelectedDiaryEntry(issue)}
        onOpenDiaryTab={() => setActiveTab('diary')}
      />

      {/* Tier 2: Main 12-Column Split Workspace */}
      <Grid container spacing={2} data-testid="registers" sx={{ flex: 1, alignItems: 'stretch', width: '100%', m: 0 }}>
        <Grid size={{ xs: 12, lg: 8 }} sx={{ display: 'flex', minWidth: 0, maxWidth: '100%' }}>
          <UnifiedRegistersCardV2
            activeTab={activeTab}
            onTabChange={setActiveTab}
            issues={issues}
            onSelectDiaryIssue={(issue) => setSelectedDiaryEntry(issue)}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }} sx={{ display: 'flex', minWidth: 0, maxWidth: '100%' }}>
          <DeliveryRegisterV2 selectedDiaryEntry={selectedDiaryEntry} setSelectedDiaryEntry={setSelectedDiaryEntry} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReportDetailsV2;
